/* eslint-disable import/no-cycle */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable array-callback-return */
import {
  isNull,
  find,
  isUndefined,
  findIndex,
  map,
  intersectionWith,
  first,
} from "lodash";

import client from "../apollo/apolloClient";
import API from "../axios";
import ApolloMessages from "../apollo/apolloMessages";
import ApolloConversations from "../apollo/conversations";
import ApolloAdmins from "../apollo/apolloAdmins";
import CONSTANTS from "../const/constants";
import { getLabelMessage } from "../const/labelService";
import {
  SET_CONVERSATION_AS_SELECTED,
  GET_CONVERSATIONS_SUCCESS,
} from "../redux/conversationsDuck";

import ApolloDatasheet from "../apollo/apolloDatasheet";
import { saveTagAction } from "../redux/tagsDuck";
import { useDispatch } from "react-redux";
import { async } from "@firebase/util";
import createTag, { editTag, getTags, upsertTag } from "./tag";
import {
  createDataSheetConfiguration,
  updateVinteInfo,
  upsertClientInformation,
} from "./datasheet";
import { saveDataSheetFieldAction } from "../redux/dataSheetConfigurationDuck";
import { findAgentByEmail } from "./getAgents";

import { apiError } from "../observability/apiError";
import { normalizeSeal } from "./conversationTelemetry";
import { queryWithProvenance } from "./provenanceProbe";
import {
  pickVisibilityFields,
  shouldSelectVisibilityFields,
} from "./conversationVisibility";

export const getQueryConversationsFilter = ({
  agents,
  tags,
  channels,
  companyId,
  selectedSpacesIds,
  skip,
  first,
  cleanedName,
  noAnswered,
  unanswered,
  isArchived,
  isArchivedBroadcast,
  isConversationValuable,
  unreadMessages,
  isAgent,
  isVinte,
  groupAdminId,
  selectedChannelsIds,
  userId,
  // aiBotVisibleToBotAdminOnly,
}, isAdminOfIds = []) => {
  try {
    const finalFilters = {};
    if (userId && isAdminOfIds?.length > 0) {
      finalFilters.agentIdIn = isAdminOfIds;
    }

    if (userId && isAdminOfIds?.length === 0 && isVinte && isAgent) {
      finalFilters.agentIdIn = [userId];
    }

    if (agents?.length > 0) {
      const isUnassignedAgentSelected = agents.some(
        (x) => x.id === CONSTANTS.UNASSIGNED_AGENT_ID
      );
      let agentsId = agents
        .filter((x) => x.id !== CONSTANTS.UNASSIGNED_AGENT_ID)
        .map((x) => x.id);
      if (isUnassignedAgentSelected) agentsId = [...agentsId, ""];
      if (finalFilters.agentIdIn) {
        finalFilters.agentIdIn = [...finalFilters.agentIdIn, ...agentsId];
      } else {
        finalFilters.agentIdIn = agentsId;
      }
    }
    if (tags?.length > 0) {
      const tagsIds = map(tags, (tag) => tag.id);
      finalFilters.tagsIdIn = tagsIds;
    }
    if (channels?.length > 0) {
      if (!isVinte || (isVinte && !isAgent)) {
        const channelsNames = map(channels, (channel) => channel.name);
        finalFilters.channelsNames = channelsNames;
      }
    }
    if (companyId) finalFilters.companyId = companyId;

    if (selectedSpacesIds?.length > 0) {
      finalFilters.channelsIds = selectedSpacesIds;
    }
    if (selectedChannelsIds?.length > 0) {
      finalFilters.channelsIds = selectedChannelsIds;
    }

    if (skip) finalFilters.skip = skip;
    if (first) finalFilters.first = first;

    if (cleanedName) finalFilters.cleanedName = cleanedName;
    else finalFilters.cleanedName = null;

    if (noAnswered) finalFilters.answered = false;
    if (isArchived) finalFilters.isArchived = true;
    if (isArchivedBroadcast) finalFilters.isBroadcastMessage = true;
    if (isConversationValuable) finalFilters.isConversationValuable = true;
    if (unanswered) finalFilters.unanswered = false;

    if (unreadMessages) finalFilters.unreadMessages = true;
    if (groupAdminId) finalFilters.groupAdminId = groupAdminId;

    // if (aiBotVisibleToBotAdminOnly) finalFilters.aiBotVisibleToBotAdminOnly = true;

    return finalFilters;
  } catch (error) {
    console.error(error);
  }
};

export const getConversations = async (
  {
    priority,
    agents,
    tags,
    channels,
    companyId,
    selectedSpacesIds,
    skip,
    first,
    cleanedName,
    isArchived,
    isArchivedBroadcast,
    isConversationValuable,
    unreadMessages,
    noAnswered,
    unanswered,
    isAgent,
    isVinte,
    groupAdminId,
    selectedChannelsIds,
    // aiBotVisibleToBotAdminOnly,
  },
  userId,
  isAdminOfIds = []
) => {
  try {
    const graphQueryFilters = getQueryConversationsFilter({
      priority,
      agents,
      tags,
      channels,
      companyId,
      selectedSpacesIds,
      skip,
      first,
      cleanedName,
      noAnswered,
      unanswered,
      isArchived,
      isArchivedBroadcast,
      isConversationValuable,
      unreadMessages,
      isAgent,
      isVinte,
      groupAdminId,
      selectedChannelsIds,
      userId,
      // aiBotVisibleToBotAdminOnly,
    }, isAdminOfIds);
    let fetchedConversations = [];
    if (!cleanedName) {
      if (groupAdminId) {
        const response = await API.post("/conversations_by_filter", {
          query: {
            priority,
            agentId: agents?.map(agent => agent?.id).pop(),
            channelId: channels?.map(channel => channel?.id).pop(),
            companyId,
            skip: skip ?? 0,
            first,
            cleanedName,
            noAnswered,
            unanswered,
            isArchived,
            isArchivedBroadcast,
            isConversationValuable,
            unreadMessages,
            groupAdminId,
            tagsIds: tags?.map(tag => tag?.id),
            ...(userId && isAdminOfIds?.length > 0 && { agentIdIn: isAdminOfIds }),
          }
        });
        fetchedConversations = response.data;
      } else {
        // `prov` is named in the document only when the backend serves it;
        // see utils/provenanceProbe for why a directive would not do.
        const data = await queryWithProvenance(client, (withProv) => ({
          query: ApolloConversations.GET_CONVERSATIONS_BY_FILTERS(
            graphQueryFilters,
            { withProv, withVisibility: shouldSelectVisibilityFields() }
          ),
          variables: graphQueryFilters,
        }));
        fetchedConversations = data?.data?.clients;

        // console.log('fetching conversations_by_filter secondary')
        // const response = await API.post("/conversations_by_filter", {
        //   query: {
        //     ...graphQueryFilters,
        //     skip:  graphQueryFilters?.skip ?? 0,
        //     custom: true,
        //   }
        // });
        // console.log('response.data conversations_by_filter', response.data)
        // fetchedConversations = response.data;
      }
    } else {
      let channelsNames;
      if (channels?.length > 0) {
        if (!isVinte || (isVinte && !isAgent)) {
          const getChannelsNames = map(channels, (channel) => channel.name);
          channelsNames = [...getChannelsNames];
        }
      }

      // Same precedence as `getQueryConversationsFilter` uses for the list
      // query: the selected space's channels bound the search, and an
      // explicit channel selection (boards origin, Velas admin) narrows it
      // further. Before, `selectedSpacesIds` was written into the GraphQL
      // variables that this door never sends, so the keyword search went out
      // without channel ids and the backend answered with every channel of
      // every space the user belongs to.
      let channelsIds;
      if (selectedSpacesIds?.length > 0) {
        channelsIds = selectedSpacesIds;
      }
      if (selectedChannelsIds?.length > 0) {
        channelsIds = selectedChannelsIds;
      }
      // `selectedSpacesIds` arrives as an array whenever the duck computed a
      // space selection: the selected space's non-SMS channels. An empty
      // array therefore means "the selected space has no channel this search
      // may read" (every channel is SMS), not "no space selected" (that is
      // `undefined`). Without `channelsIds` the backend falls back to every
      // channel of every space the user belongs to, so that search is not
      // sent at all: there is nothing in the space for it to find.
      const spaceHasNoSearchableChannel =
        Array.isArray(selectedSpacesIds) &&
        selectedSpacesIds.length === 0 &&
        !channelsIds;
      const graphQuerySearchFilter = {
        companyId,
        keyword: cleanedName,
        channelsNames,
        channelsIds,
        ...(groupAdminId && { groupAdminId: groupAdminId }),
        agentIdIn: graphQueryFilters?.agentIdIn,
        skip: graphQueryFilters?.skip,
        first: graphQueryFilters?.first,
      };

      if (userId && isAdminOfIds?.length > 0) {
        if (graphQuerySearchFilter.agentIdIn) {
          graphQuerySearchFilter.agentIdIn = [...graphQuerySearchFilter.agentIdIn, ...isAdminOfIds];
        } else {
          graphQuerySearchFilter.agentIdIn = isAdminOfIds;
        }
      }

      if (groupAdminId) {
        const response = await API.post("/conversations_by_filter", {
          query: {
            channelId: channels?.map(channel => channel?.id).pop(),
            companyId,
            skip: skip ?? 0,
            first,
            keyword: cleanedName,
            groupAdminId,
          }
        });
        fetchedConversations = response.data;
      } else if (spaceHasNoSearchableChannel) {
        fetchedConversations = [];
      } else {
        const response = await API.post("/conversations_by_filter", {
          query: {
            ...graphQuerySearchFilter,
            skip:  graphQueryFilters?.skip ?? 0,
            custom: true,
          }
        });
        fetchedConversations = response.data;
        // const data = await client.query({
        //   query: ApolloConversations.GET_CONVERSATIONS_BY_SEARCHING_KEYWORD(
        //     graphQuerySearchFilter
        //   ),
        //   variables: graphQuerySearchFilter,
        // });
        // console.log("getConversations data => ", data);
        // console.log("graphQuerySearchFilter data => ", graphQuerySearchFilter);

        // fetchedConversations = data?.data?.clients;
      }

    }

    const messageIds = fetchedConversations
      .filter(x => x?.lastMessageId && x?.lastMessageId !== "")
      .map((x) => x?.lastMessageId)
    
    let lastMessages = [];

    if (messageIds?.length > 0) {
      const {
        data: { messages },
      } = await client.query({
        query: ApolloMessages.GET_MESSAGES_BY_ID,
        variables: { ids: messageIds },
      });
      lastMessages = messages;
    }

    const newConversations = [];
    for await (const conversation of fetchedConversations) {
      try {
        const message = find(lastMessages, ["clientId", conversation.id]);
        if (message?.time)
          message.time =
            message.time && parseInt(`${message.time.toString()}000`, 10);
        let agent = { id: null, name: null };
        if (conversation.agent?.id) agent = { ...conversation.agent };

        newConversations.push({
          id: conversation.id,
          platform: conversation.channel?.platform,
          name: conversation.name,
          nameFromChannel: conversation.nameFromChannel,
          key: conversation.key,
          senderId: conversation.senderId,
          senderIdType: conversation.senderIdType,
          whatsappUserId: conversation.whatsappUserId,
          whatsappParentUserId: conversation.whatsappParentUserId,
          whatsappUsername: conversation.whatsappUsername,
          phoneNumber: conversation.phoneNumber,
          displayName: conversation.displayName,
          cleanedName: conversation.cleanedName,
          imageUrl: conversation.imageUrl,
          accessId: conversation.accessId,
          channel: { ...conversation.channel },
          company: { id: companyId },
          hasUpdates: false,
          agent,
          priority: conversation.priority,
          unreadMessages: conversation.unreadMessagesCount,
          tags: conversation.tags,
          lastMessage: !isUndefined(message) ? message : {},
          lastMessageId: conversation.lastMessageId,
          answered: conversation.answered,
          isArchived: conversation.isArchived,
          isBroadcastMessage: conversation.isBroadcastMessage,
          category: conversation.category,
          isConversationValuable:
            conversation?.isConversationValuable ?? null,
          setValuableByUser: conversation.setValuableByUser,
          hasFollowUpMessage: conversation.hasFollowUpMessage,
          participants: conversation.participants,
          isGroupMessage: conversation.senderId.includes("@g.us"),
          pageId: conversation.pageId,
          pageToken: conversation.pageToken,
          whatsappStartedAt: conversation.whatsappStartedAt,
          whatsappLastMessageAt: conversation.whatsappLastMessageAt,
          isClosed: conversation.isClosed,
          groupAdminId: conversation.groupAdminId,
          hubspotId: conversation.hubspotId,
          hubspotDealId: conversation.hubspotDealId,
          // The server's provenance seal (gql or REST door), for telemetry.
          prov: normalizeSeal(conversation.prov),
          // Only when the backend sent them (feature on): R4.
          ...pickVisibilityFields(conversation),
        });
      } catch (error) {
        console.error(error);
        return newConversations.length > 0 ? newConversations : [];
      }
    }

    return newConversations;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setIsArchived = async (id, setValuableIsArchived) => {
  const data = await client.query({
    query: ApolloConversations.SET_IS_ARCHIVED,
    variables: { id, setValuableIsArchived },
  });
  return data;
};

export const getBroadCastConversationsQuery = async (companyId) => {
  const { data } = await client.query({
    query: ApolloConversations.GET_BROADCAST_CONVERSATIONS,
    variables: { companyId },
  });
  return data;
};

export const updateClientInfo = async (clientInfo) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.UPDATE_CLIENT_INFO,
      variables: clientInfo,
    });
    if (data) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};


export const createClientFromPhone = async (
  newClientData,
  agentId,
  importContact = false,
  updateProgress = null,
  companyId = null,
  spaceId = null
) => {
  if (importContact) {
    let agentResult = null;
    const clientCompanyId = newClientData[0]?.data?.companyId;
    // Para la compañía específica, usar spaceId si está disponible
    const useSpaceId = clientCompanyId === CONSTANTS.SPACE_FILTERED_COMPANY_ID ? spaceId : null;
    const { tags: dbTags } = await getTags(clientCompanyId, useSpaceId);
    const colors = [
      "#f61e44",
      "#a300ff",
      "#00cd7e",
      "#072e93",
      "#ffc730",
      "#cd81fb",
      "#27b1b3",
    ];
    const newClientsDataResult = [];
    const finalStatus = [];
    // const agentName = useSelector((state) => state.user?.data?.name);
    for (const clientData of newClientData) {
      try {
        const { data, customFields } = clientData;
        if (data.statusInfo.status === "error") {
          finalStatus.push(data.statusInfo);
          continue;
        }
        const connectedTags = [];
        if (data?.tags) {
          const clientTags = data?.tags?.split(",").map((tag) => tag.trim());
          for await (const tag of clientTags) {
            const isTagInDb = dbTags?.find((t) => t.name === tag);
            if (!isTagInDb?.id) {
              const newTag = await createTag(
                tag,
                colors[Math.floor(Math.random() * colors.length)],
                data.companyId,
                `${data.companyId}-${tag}`,
                useSpaceId
              );
              dbTags.push(newTag);
              connectedTags.push(newTag.id);
            } else {
              await editTag(
                isTagInDb.id,
                isTagInDb.name,
                isTagInDb.color,
                isTagInDb?.key ? isTagInDb.key : `${data.companyId}-${tag}`
              );
              connectedTags.push(isTagInDb.id);
            }
          }
        }

        const responseKey = await client.query({
          query: ApolloConversations.GET_CONVERSATION_BY_KEY,
          variables: { key: data.key },
        });

        //console.log('responseKey => ', responseKey)

        let clientResult = null;
        try {
          if (data?.agentEmail) {
            // `report: false` — este error se traga a propósito (el `catch` de
            // abajo hace `continue`) y hasta hoy nunca llegaba a Sentry. Como
            // estamos DENTRO del bucle por fila del CSV, reportarlo convertiría
            // una importación de miles de contactos en miles de eventos.
            const agent = await findAgentByEmail(data?.agentEmail, {
              report: false,
            });
            agentResult = agent[0];
          }
        } catch (error) {
          console.log("ERROR", error);
          continue;
        }
        if (responseKey?.data?.client?.id) {
          clientResult = responseKey?.data?.client;
          finalStatus.push({
            status: "duplicado",
            message: "El contacto ya existe",
            number: data.senderId?.toString(),
          });
        } else {
          const getAgentId = agentResult?.id;
          const clientData = {
            channel: { connect: { id: data?.channelId } },
            channelId: data.channelId,
            channelIdString: data.channelId,
            senderId: data.senderId?.toString(),
            company: { connect: { id: data.companyId } },
            companyId: data.companyId,
            companyIdString: data.companyId,
            key: data?.channelId + data.senderId,
            cleanedName: data.cleanedName,
            lastUpdate: new Date(),
            isConversationValuable: null,
            agent: { connect: { id: getAgentId ? getAgentId : agentId } },
            agentId: getAgentId ? getAgentId : agentId,
            categoryId: "5ed5b4670274390007afcc59",
            category: { connect: { id: "5ed5b4670274390007afcc59" } },
            name: data.nameFromChannel,
            ...(connectedTags.length > 0 && {
              tags: connectedTags.map((x) => ({ id: x })),
              tagsString: connectedTags?.reduce(
                (acc, tag) => `${acc}-${tag}`,
                ""
              ),
            }),
          };
          const response = await client.mutate({
            mutation: ApolloConversations.CREATE_CLIENT_FROM_PHONE,
            variables: clientData,
          });
          clientResult = response.data.createClient;
          finalStatus.push({
            status: "creado",
            message: "Contacto creado exitosamente",
            number: data.senderId?.toString(),
          });
        }

        for await (const customField of customFields) {
          const value = customField.value;
          const fieldName = customField.name
            .trim()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const key = `${data.companyId}-${fieldName}`;

          const res = await client.query({
            query: ApolloDatasheet.GET_DATASHEET_CONFIGURATION_BY_KEY,
            variables: { key },
          });
          const dataSheetByKey = res.data.dataSheetConfigurations;
          let dataSheet = null;
          // console.log("dataSheetByKey:", dataSheetByKey);

          if (dataSheetByKey.length === 0) {
            const field = { name: fieldName, type: "string", options: [], key };
            dataSheet = await createDataSheetConfiguration(
              field,
              data.companyId
            );
          } else {
            dataSheet = dataSheetByKey[0];
          }
          const clientInfoKey = clientResult?.id + dataSheet?.id;
          await upsertClientInformation(
            clientInfoKey,
            clientResult.id,
            dataSheet.id,
            value
          );
        }

        newClientsDataResult.push({
          name: data.nameFromChannel,
          lastName:
            data?.nameFromChannel && data?.nameFromChannel?.split(" ")[1],
          phone: data.senderId,
          tags: data.tags,
          agent: agentResult?.name ? agentResult?.name : data.agentName,
          channel: "WhatsApp",
          createdAt: data.createdAt,
          moreInfo: "Additional details...",
          clientInfo: customFields,
        });
        updateProgress((prevProgress) => (prevProgress = prevProgress + 12));
      } catch (error) {
        console.log("ERROR", error);
        continue;
      }
    }

    return { newClientsDataResult, finalStatus };
  } else {
    const { phone, name, companyId, channelId, tags, notes } = newClientData;
    const cleanedName = `${name
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g)
      .replace(/\s/g, "")
      .toLowerCase()} ${phone}`;

    let isUpdatedClient = false;
    try {
      const clientData = {
        senderId: `${phone}`,
        name,
        companyId,
        companyIdString: companyId,
        channelId,
        channelIdString: channelId,
        key: `${channelId + phone}`,
        cleanedName,
        lastUpdate: new Date().toISOString(),
        agentId,
        agentIdString: agentId,
      };

      const responseKey = await client.query({
        query: ApolloConversations.GET_CONVERSATION_BY_KEY,
        variables: { key: `${channelId + phone}` },
      });

      let clientResult = null;

      if (responseKey?.data?.client?.id) {
        clientResult = responseKey?.data?.client;
        isUpdatedClient = true;
      } else {
        const response = await client.mutate({
          mutation: ApolloConversations.CREATE_CLIENT_FROM_PHONE,
          variables: clientData,
        });
        clientResult = response.data.createClient;
        if (companyId === CONSTANTS.VINTE_COMPANY_ID) {
          updateVinteInfo(clientResult.id).then((res) => {
          }).catch((error) => {
            console.error('updateVinteInfo', error);
          });
        }
      }
      return { clientResult, isUpdatedClient };
    } catch (error) {
      throw error;
    }
  }
};

export const getPlatformApiFromPhone = async (companyId) => {
  try {
    const response = await client.mutate({
      mutation: ApolloConversations.GET_PLATFORM_API_PHONE,
      variables: { companyId },
    });
    return response.data.channels;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const changeCategory = async (id, categoryId) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.CHANGE_CATEGORY_CLIENT,
      variables: { id, categoryId },
    });
    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_REASSIGNING_AGENT", error, {
      operation: "changeCategory",
      module: "utils/getConversations",
    });
  }
};

export const sendToCrm = async (clientId) => {
  try {
    const response = await API.post("/sendToCRM", { clientId });
    return response.data;
  } catch (error) {
    console.log(error);
    return { code: 400, description: "Error al enviar información al CRM" };
  }
};

export const getClientInfo = async (clientId) => {
  try {
    const { data } = await client.query({
      query: ApolloConversations.GET_CLIENT_INFO,
      variables: { id: clientId },
    });
    if (data && data.client) {
      return data.client;
    }
    return { error: "Error al obtener información del cliente" };
  } catch (error) {
    return { error };
  }
};

export const connectTag = async (id, tagId) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.CONVERSATION_ADD_TAGS,
      variables: { id, tagId },
    });
    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_ADDING_TAG", error, {
      operation: "connectTag",
      module: "utils/getConversations",
    });
  }
};

export const disconnectTag = async (id, tagId) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.CONVERSATION_REMOVE_TAGS,
      variables: { id, tagId },
    });

    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_REMOVING_TAG", error, {
      operation: "disconnectTag",
      module: "utils/getConversations",
    });
  }
};

export const getMessageStatusSubscription = async (companyId) => {
  try {
    const subscriptionMessageStatus = await client.subscribe({
      query: ApolloMessages.MESSAGE_STATUS_SUBSCRIBE,
      variables: companyId,
    });

    return { subscriptionMessageStatus };
  } catch (error) {
    console.error(error);
  }
};

export const addNewConversation = async (
  newConversation,
  conversations,
  currentConversationId,
  updatedFields
) => {
  const updateCounter = updatedFields?.some((x) => x === "lastMessageId");
  const updateConversation = !updatedFields?.length !== 0 || updateCounter;

  const lbls = getLabelMessage([
    "newMessageNotification",
    "newConversationNotification",
  ]);
  const foundConversationIndex = findIndex(conversations, [
    "id",
    newConversation.id,
  ]);

  const { data: lastMessageData } = await client.query({
    query: ApolloMessages.GET_LAST_MESSAGE_BY_CLIENT_ID,
    variables: { clientId: newConversation.id },
  });
  const lastMessages = lastMessageData.messages;

  let unreadMessages = 0;
  if (currentConversationId !== newConversation.id) {
    if (updateCounter) {
      if (
        foundConversationIndex === -1 ||
        !conversations[foundConversationIndex]?.unreadMessages
      ) {
        unreadMessages = 1;
      } else {
        unreadMessages =
          conversations[foundConversationIndex]?.unreadMessages + 1;
      }
    } else {
      unreadMessages = conversations[foundConversationIndex]?.unreadMessages;
    }
  }
  const newConversationFormated = {
    id: newConversation.id,
    platform: newConversation.channel?.platform,
    nameFromChannel: newConversation.nameFromChannel,
    senderIdType: newConversation.senderIdType,
    whatsappUserId: newConversation.whatsappUserId,
    whatsappParentUserId: newConversation.whatsappParentUserId,
    whatsappUsername: newConversation.whatsappUsername,
    phoneNumber: newConversation.phoneNumber,
    displayName: newConversation.displayName,
    imageUrl: newConversation.imageUrl,
    accessId: newConversation.accessId,
    senderId: newConversation.senderId,
    channel: newConversation.channel,
    company: newConversation.company,
    agent: newConversation.agent,
    priority: newConversation.priority,
    unreadMessages,
    tags: newConversation.tags?.length > 0 ? newConversation.tags : [],
    lastMessage: lastMessages.length > 0 ? lastMessages[0] : {},
    answered: newConversation.answered,
    category: newConversation.category,
    hasUpdates:
      updateConversation && currentConversationId !== newConversation.id,
    isConversationValuable: newConversation.isConversationValuable,
    setValuableByUser: newConversation.setValuableByUser,
    hasFollowUpMessage: newConversation.hasFollowUpMessage,
    isGroupMessage: newConversation.senderId.includes("@g.us"),
    pageId: newConversation.pageId,
    pageToken: newConversation.pageToken,
    whatsappStartedAt: newConversation.whatsappStartedAt,
    whatsappLastMessageAt: newConversation.whatsappLastMessageAt,
    prov: normalizeSeal(newConversation.prov),
    ...pickVisibilityFields(newConversation),
  };

  if (foundConversationIndex === -1) {
    if (Notification.permission === "granted") {
      const notification = new Notification(lbls.newConversationNotification, {
        body: `${newConversationFormated.nameFromChannel}`,
      });
      setTimeout(notification.close.bind(notification), 5000);
    }
    return {
      foundIndex: -1,
      conversations: [newConversationFormated, ...conversations],
    };
  }

  const newConversations = [...conversations];
  const currentConversation = { ...newConversationFormated };

  if (updateConversation) {
    newConversations.splice(foundConversationIndex, 1);

    if (
      updateCounter &&
      lastMessages?.[0]?.sender === CONSTANTS.CLIENT_SENDER
    ) {
      if (Notification.permission === "granted") {
        const notification = new Notification(lbls.newMessageNotification, {
          body: `${newConversationFormated.nameFromChannel}: ${lastMessages?.[0]?.content}`,
        });
        setTimeout(notification.close.bind(notification), 5000);
      }
    }

    return {
      foundIndex: foundConversationIndex,
      conversations: [newConversationFormated, ...newConversations],
      currentConversation,
    };
  }

  newConversations[foundConversationIndex] = newConversationFormated;
  return {
    foundIndex: foundConversationIndex,
    conversations: newConversations,
    currentConversation,
  };
};

const deleteConversationByIndex = (previousConversations, selectedIndex) => {
  const newConversations = [...previousConversations];
  newConversations.splice(selectedIndex, 1);
  return newConversations;
};

const verifyFilters = (filters, deletedConversation) => {
  if (filters?.agents?.length > 0) {
    const hasConversationAgent = filters.agents.some(
      (x) => x.id === deletedConversation.agent?.id
    );
    if (!hasConversationAgent) return false;
  }

  if (filters?.categories?.length > 0) {
    const hasConversationAgent = filters.categories.some(
      (x) => x.id === deletedConversation.category?.id
    );
    if (!hasConversationAgent) return false;
  }

  if (filters?.companyId) {
    const hasConversationAgent =
      filters.companyId === deletedConversation.company.id;
    if (!hasConversationAgent) return false;
  }

  if (filters?.channels?.length > 0) {
    const hasConversationAgent = filters.channels.some(
      (x) => x.name === deletedConversation.channel?.platform?.name
    );
    if (!hasConversationAgent) return false;
  }

  if (filters?.nameFromChannel) {
    const hasConversationAgent = deletedConversation.nameFromChannel
      .toLowerCase()
      .includes(filters.nameFromChannel.toLowerCase());
    if (!hasConversationAgent) return false;
  }

  if (filters?.priority?.length > 0) {
    let hasConversationAgent = false;
    if (
      filters.priority.includes("high") &&
      deletedConversation.priority <= 0.333
    )
      hasConversationAgent = true;
    else if (
      filters.priority.includes("medium") &&
      deletedConversation.priority <= 0.666
    )
      hasConversationAgent = true;
    else if (
      filters.priority.includes("low") &&
      deletedConversation.priority > 0.666
    )
      hasConversationAgent = true;
    if (!hasConversationAgent) return false;
  }

  if (filters?.selectedSpacesIds?.length > 0) {
    const hasConversationAgent = filters.selectedSpacesIds.some(
      (x) => x === deletedConversation.channel?.id
    );
    if (!hasConversationAgent) return false;
  }

  if (filters?.tags?.length > 0) {
    const deletedConversationIncludesTagsFilter = intersectionWith(
      deletedConversation.tags,
      filters.tags,
      (arrVal, othVal) => arrVal.id === othVal.id
    );
    if (deletedConversationIncludesTagsFilter?.length === 0) return false;
  }

  return true;
};

const updateUnsubscribeQuery = async (currentConversations) => {
  const unassignedAgentObservable = await client.subscribe({
    query: ApolloAdmins.UNSUBSCRIBE_QUERY,
    variables: { ids: currentConversations.map((x) => x.id) },
  });

  return unassignedAgentObservable;
};

export const deleteConversationCallback = async (
  deletedConversation,
  conversations,
  filters
) => {
  const deletedIndex = findIndex(conversations, ["id", deletedConversation.id]);
  if (deletedIndex === -1) return {};

  const conversationFulfillFilters = verifyFilters(
    filters,
    deletedConversation
  );

  if (conversationFulfillFilters) return {};
  const newConversations = deleteConversationByIndex(
    conversations,
    deletedIndex
  );
  const newUnsubscribeQuery = await updateUnsubscribeQuery(newConversations);
  return { newConversations, newUnsubscribeQuery };
};

export const getMessageById = async (messageId) => {
  const { data: messageData } = await client.query({
    query: ApolloMessages.GET_MESSAGE_BY_ID,
    variables: { messageId },
  });
  return messageData.message;
};

export const getConversationByKey = async (key) => {
  try {
    const { data } = await client.query({
      query: ApolloConversations.GET_CONVERSATION_BY_KEY,
      variables: { key },
    });
    return data.client;
  } catch (e) {
    console.log("ERROR getConversationByKey => ", e);
  }
};

/**
 * Trae una conversación por id.
 *
 * ⚠️ **Propaga el fallo a propósito.** Antes lo registraba en consola y
 * devolvía `undefined`, y eso tenía una consecuencia invisible: quien la usa
 * para REPONER la conversación abierta tras un restart no podía distinguir
 * "no existe" de "la red se cayó", así que ante un fallo de red daba el chat
 * por perdido y se lo cerraba al asesor en silencio — justo al reconectar,
 * que es cuando la red está peor. El llamador tiene que decidir qué hacer con
 * el error; tragárselo aquí le quita esa opción.
 */
export const getConversationID = async (id) => {
  const { data } = await queryWithProvenance(client, (withProv) => ({
    query: ApolloConversations.getConversationByIdDocument({
      withProv,
      withVisibility: shouldSelectVisibilityFields(),
    }),
    variables: { id },
  }));
  return data.client;
};

/**
 * A conversation by id, shaped like a Pusher `newClient` payload so it can go
 * through `updateConverations` (and its filter checks) unchanged. Used when a
 * conversation becomes visible to humans again (R6). Resolves `null` when it
 * does not exist for this user or has no last message (the inbox query skips
 * those too). Network errors propagate.
 */
export const getConversationForRealtime = async (id) => {
  const node = await getConversationID(id);
  if (!node || !node.id || !node.lastMessageId) return null;
  const { data } = await client.query({
    query: ApolloMessages.GET_MESSAGES_BY_ID,
    variables: { ids: [node.lastMessageId] },
  });
  const lastMessage = (data?.messages || []).find(
    (message) => message && message.id === node.lastMessageId
  );
  if (!lastMessage) return null;
  return {
    type: "newClient",
    client: {
      ...node,
      platform: node.channel?.platform,
      unreadMessages: node.unreadMessagesCount,
      lastMessage,
    },
  };
};

export const updateClientUsernameMutation = async (
  id,
  nameFromChannel,
  cleanedName
) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.UPDATE_CLIENT_NAME,
      variables: { id, nameFromChannel, cleanedName },
    });
    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_UPDATING_USER_NAME", error, {
      operation: "updateClientUsernameMutation",
      module: "utils/getConversations",
    });
  }
};

export const updateClientPhoneMutation = async (
  id,
  cleanedName,
  key,
  senderId,
  phoneNumber
) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.UPDATE_CLIENT_PHONE,
      variables: { id, cleanedName, key, senderId, phoneNumber },
    });
    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_UPDATING_USER_PHONE", error, {
      operation: "updateClientPhoneMutation",
      module: "utils/getConversations",
    });
  }
};

// Dos consultas en vez de una con `OR`: el esquema desplegado solo declara `AND`
// en ClientWhereInput, así que un `OR` ahí devuelve 400 siempre. Se lanzan en
// paralelo y se unen por id, conservando la intención de 0ba96aacb de comprobar
// tanto senderId como phoneNumber. Ver #216.
// `clientId` excluye al propio contacto que se está editando: sin él, recortar un
// dígito del número hace que el contacto coincida CONSIGO MISMO por
// `phoneNumber_contains` / `senderId_contains` y su edición se bloquee como
// duplicado. Ver #216.
export const checkExistedPhone = async (companyId, channelId, phone, clientId) => {
  try {
    const variables = { companyId, channelId, phone, clientId };
    const [porSenderId, porPhoneNumber] = await Promise.all([
      client.query({
        query: ApolloConversations.CHECK_EXISTED_PHONE_BY_SENDER_ID,
        variables,
      }),
      client.query({
        query: ApolloConversations.CHECK_EXISTED_PHONE_BY_PHONE_NUMBER,
        variables,
      }),
    ]);

    const encontrados = [
      ...(porSenderId?.data?.clients || []),
      ...(porPhoneNumber?.data?.clients || []),
    ];
    // Unión por id: un mismo cliente puede coincidir por los dos campos.
    return [...new Map(encontrados.map((c) => [c.id, c])).values()];
  } catch (error) {
    console.error("ERROR_AT_CHECKING_EXISTED_PHONE => ", error);
    throw apiError("ERROR_AT_CHECKING_EXISTED_PHONE", error, {
      operation: "checkExistedPhone",
      module: "utils/getConversations",
    });
  }
};

export const updateValuableByUserMutation = async (id, value) => {
  try {
    const { data } = await client.mutate({
      mutation: ApolloConversations.UPDATE_CONVERSATION_CLASSIFICATION,
      variables: {
        id,
        isConversationValuable: value,
        setValuableByUser: value,
      },
    });
    return data.updateClient;
  } catch (error) {
    throw apiError("ERROR_UPDATING_VALUABLE_CLASSIFICATION", error, {
      operation: "updateValuableByUserMutation",
      module: "utils/getConversations",
    });
  }
};

export const deleteConversation = async (data) => {
  try {
    const response = await API.post("/delete-conversation", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getClientReport = async (
  companyId,
  companyName,
  initialDate,
  endDate,
  channelIds,
  filters,
  skip = 0,
  rol,
  userId
) => {
  try {
    const graphQueryFilters = { companyId, initialDate, endDate };
    if (companyName === CONSTANTS.VINTE_COMPANY_NAME && channelIds?.length > 0)
      graphQueryFilters.channelIds = channelIds;

    // if (filters?.isArchived) graphQueryFilters.isArchived = true;
    // if (filters?.noAnswered) graphQueryFilters.answered = false;
    // if (filters?.unread) graphQueryFilters.unreadMessages = true;
    // if (filters?.broadcast) graphQueryFilters.isArchivedBroadcast = true;
    // if (filters?.isConversationValuable)
    //   graphQueryFilters.isConversationValuable = true;
    // if (filters?.agents?.length > 0)
    //   graphQueryFilters.agentIdIn = [...filters.agents];
    // if (filters?.tags?.length > 0)
    //   graphQueryFilters.tagsIdIn = [...filters.tags];

    // let platforms = [];
    // if (filters?.whatsappChannel) {
    //   platforms.push("WHATSAPP");
    // }
    // if (filters?.messengerChannel) {
    //   platforms.push("MESSENGER");
    // }

    // if (platforms.length > 0) {
    //   graphQueryFilters.channelsNames = platforms;
    // }
    graphQueryFilters.skip = skip;
    console.log("graphQueryFiltersskip", graphQueryFilters.skip);
    graphQueryFilters.first = 50;

    if (rol === CONSTANTS.AGENT_PERMISSION || rol === "Agent" || rol === "Agente" || rol === "agente") {
      graphQueryFilters.agentIdIn = [userId];
    }

    console.log("graphQueryFilters", graphQueryFilters);
    const { data: clients } = await client.query({
      query: ApolloConversations.GET_CLIENTS_REPORT(graphQueryFilters),
      variables: graphQueryFilters,
    });

    if (companyName === CONSTANTS.VINTE_COMPANY_NAME) {
      const { data: ds } = await client.query({
        query: ApolloDatasheet.GET_DATASHEET_CONFIGURATION_BY_COMPANY_ID,
        variables: { companyId },
      });
      const plazaDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "plaza"
      );
      const emailDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "correoElectronico"
      );
      const nombreClienteDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "nombreCliente"
      );
      const telefonoOtrosDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "telefonoOtros"
      );

      const keyIn = [];

      if (clients?.clients?.length > 0) {
        clients.clients.forEach((x) => {
          keyIn.push(x.id + plazaDs.id);
          keyIn.push(x.id + emailDs.id);
          keyIn.push(x.id + telefonoOtrosDs.id);
          keyIn.push(x.id + nombreClienteDs.id);
        });

        let clientInfoes = [];
        if (keyIn?.length > 1000) {
          const chunkSize = 1000;
          for (let i = 0; i < keyIn.length; i += chunkSize) {
            const chunk = keyIn.slice(i, i + chunkSize);
            console.log(chunk);
            const { data: clientInfoesData } = await client.query({
              query: ApolloConversations.GET_CLIENT_VINTE_EXTRA_INFO({
                keyIn: chunk,
              }),
              variables: { keyIn: chunk },
            });
            clientInfoes.push(...clientInfoesData.clientInfoes);
          }
        } else {
          const { data: clientInfoesData } = await client.query({
            query: ApolloConversations.GET_CLIENT_VINTE_EXTRA_INFO({ keyIn }),
            variables: { keyIn },
          });
          clientInfoes = [...clientInfoesData.clientInfoes];
          console.log(clientInfoes);
        }
        const clientInfoesSorted = {};
        clientInfoes.forEach((x) => {
          if (clientInfoesSorted[x.clientId]) {
            clientInfoesSorted[x.clientId] = {
              ...clientInfoesSorted[x.clientId],
              [x.fieldName.id]: x.value,
            };
          } else {
            clientInfoesSorted[x.clientId] = { [x.fieldName.id]: x.value };
          }
        });
        return clients?.clients?.map((client) => {
          const c = {
            ...client,
          };
          if (clientInfoesSorted[client.id]?.[nombreClienteDs.id]) {
            c.name = clientInfoesSorted[client.id]?.[nombreClienteDs.id];
          }
          if (clientInfoesSorted[client.id]?.[emailDs.id]) {
            c.correoElectronico = clientInfoesSorted[client.id]?.[emailDs.id];
          }
          if (clientInfoesSorted[client.id]?.[plazaDs.id]) {
            c.plaza = clientInfoesSorted[client.id]?.[plazaDs.id];
          }
          if (clientInfoesSorted[client.id]?.[telefonoOtrosDs.id]) {
            c.number =
              clientInfoesSorted[client.id]?.[telefonoOtrosDs.id] ||
              client.senderId;
          }
          return c;
        });
      }
    }

    return clients.clients;
  } catch (error) {
    console.log(error);
    throw apiError("ERROR_GETTING_REPORT", error, {
      operation: "getClientReport",
      module: "utils/getConversations",
    });
  }
};
export const getClientReportToExport = async (
  filterContactsBy,
  companyId,
  companyName,
  initialDate,
  endDate,
  channelsIds,
  keyword,
  tagsIds,
  agentId,
  userId,
  isAdminOfIds = []
) => {
  try {
    const graphQueryFilters = {
      filterContactsBy,
      companyId,
      createdAtFrom: initialDate,
      createdAtTo: endDate,
      keyword, tagsIds,
      channelsIds,
      agentId: agentId === 'Todos' ? null : agentId
    };
    // if (companyName === CONSTANTS.VINTE_COMPANY_NAME && channelIds?.length > 0)
    //   graphQueryFilters.channelIds = channelIds;

    console.log("graphQueryFilters", graphQueryFilters);
    // const { data: clients } = await client.query({
    //   query: ApolloConversations.GET_CLIENTS_REPORT(graphQueryFilters),
    //   variables: graphQueryFilters,
    // });

    if (userId && isAdminOfIds?.length > 0) {
      graphQueryFilters.agentIdIn = isAdminOfIds;
    }

    const response = await API.post("/conversations_by_filter", {
      query: {
        ...graphQueryFilters,
        skip: 0,
        first: 5000,
        custom: true,
      }
    });

    const clients = { clients: response?.data }

    if (companyName === CONSTANTS.VINTE_COMPANY_NAME) {
      const { data: ds } = await client.query({
        query: ApolloDatasheet.GET_DATASHEET_CONFIGURATION_BY_COMPANY_ID,
        variables: { companyId },
      });
      const plazaDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "plaza"
      );
      const emailDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "correoElectronico"
      );
      const nombreClienteDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "nombreCliente"
      );
      const telefonoOtrosDs = ds?.dataSheetConfigurations.find(
        (x) => x.name === "telefonoOtros"
      );

      const keyIn = [];

      if (clients?.clients?.length > 0) {
        clients.clients.forEach((x) => {
          keyIn.push(x.id + plazaDs.id);
          keyIn.push(x.id + emailDs.id);
          keyIn.push(x.id + telefonoOtrosDs.id);
          keyIn.push(x.id + nombreClienteDs.id);
        });

        let clientInfoes = [];
        if (keyIn?.length > 1000) {
          const chunkSize = 1000;
          for (let i = 0; i < keyIn.length; i += chunkSize) {
            const chunk = keyIn.slice(i, i + chunkSize);
            console.log(chunk);
            const { data: clientInfoesData } = await client.query({
              query: ApolloConversations.GET_CLIENT_VINTE_EXTRA_INFO({
                keyIn: chunk,
              }),
              variables: { keyIn: chunk },
            });
            clientInfoes.push(...clientInfoesData.clientInfoes);
          }
        } else {
          const { data: clientInfoesData } = await client.query({
            query: ApolloConversations.GET_CLIENT_VINTE_EXTRA_INFO({ keyIn }),
            variables: { keyIn },
          });
          clientInfoes = [...clientInfoesData.clientInfoes];
          console.log(clientInfoes);
        }
        const clientInfoesSorted = {};
        clientInfoes.forEach((x) => {
          if (clientInfoesSorted[x.clientId]) {
            clientInfoesSorted[x.clientId] = {
              ...clientInfoesSorted[x.clientId],
              [x.fieldName.id]: x.value,
            };
          } else {
            clientInfoesSorted[x.clientId] = { [x.fieldName.id]: x.value };
          }
        });
        return clients?.clients?.map((client) => {
          const c = {
            ...client,
          };
          if (clientInfoesSorted[client.id]?.[nombreClienteDs.id]) {
            c.name = clientInfoesSorted[client.id]?.[nombreClienteDs.id];
          }
          if (clientInfoesSorted[client.id]?.[emailDs.id]) {
            c.correoElectronico = clientInfoesSorted[client.id]?.[emailDs.id];
          }
          if (clientInfoesSorted[client.id]?.[plazaDs.id]) {
            c.plaza = clientInfoesSorted[client.id]?.[plazaDs.id];
          }
          if (clientInfoesSorted[client.id]?.[telefonoOtrosDs.id]) {
            c.number =
              clientInfoesSorted[client.id]?.[telefonoOtrosDs.id] ||
              client.senderId;
          }
          return c;
        });
      }
    }

    return clients.clients;
  } catch (error) {
    console.log(error);
    throw apiError("ERROR_GETTING_REPORT", error, {
      operation: "getClientReportToExport",
      module: "utils/getConversations",
    });
  }
};

export const getConversationDataByKey = async (key) => {
  try {
    const { data } = await client.query({
      query: ApolloConversations.GET_CONVERSATION_DATA_BY_KEY,
      variables: { key },
    });
    return data.client;
  } catch (e) {
    console.log("ERROR getConversationByKey => ", e);
  }
};
